import React from 'react';

export default function Input({
  label,
  error,
  helper,
  className = '',
  containerClassName = '',
  required = false,
  ...props
}) {
  const baseInputStyles = 'w-full px-4 py-2.5 rounded-xl border-2 transition-colors duration-200 focus:outline-none';
  const normalStyles = 'border-neutral-200 focus:border-primary-500';
  const errorStyles = 'border-danger-300 focus:border-danger-500';

  return (
    <div className={`${containerClassName}`}>
      {label && (
        <label className="block text-sm font-medium text-neutral-700 mb-2">
          {label}
          {required && <span className="text-danger-500 ml-1">*</span>}
        </label>
      )}
      <input
        className={`${baseInputStyles} ${error ? errorStyles : normalStyles} ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-1.5 text-sm text-danger-500">{error}</p>
      )}
      {helper && !error && (
        <p className="mt-1.5 text-sm text-neutral-500">{helper}</p>
      )}
    </div>
  );
}
